import React, { useState, useRef } from "react";
import "./Navbar.css";
import { FaBars, FaPhone, FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from '../../images/logoSuffah.png'

const Navbar = () => {
  const navRef = useRef();
  const showNavbar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const closeNavbar = () => {
    navRef.current.classList.remove("responsive_nav");
  };

  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.body.classList.toggle("dark-mode", !isDarkMode);
  };

  
  return (
    <header>
      <div className={`navbar ${isDarkMode ? "dark-mode-navbar" : ""}`}>
        <div className="navbar-left">
          <img src={logo} style={{height:'50px'}} alt="Logo" className="navbar-logo" />
        </div>
        <div className="navbar-right">
          <nav ref={navRef}>
            <NavLink exact="true" to="/"  className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>Home</NavLink>
            <NavLink exact="true" to="/about-us"  className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>About Us</NavLink>
            <NavLink exact="true" to="/branches"  className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>Branches</NavLink>
            <NavLink exact="true" to="/why-us"  className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>Why Us</NavLink>
            <NavLink exact="true" to="/events"  className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>Gallery</NavLink>
            {/* <NavLink to="/gallery" activeClassName="active" onClick={closeNavbar}>Gallery</NavLink> */}
            <NavLink exact="true" to="/staff"  className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>Staff</NavLink>
            <NavLink exact="true" to="/contact-us" className={({ isActive }) => isActive ? "active" : ""} onClick={closeNavbar}>Contact Us</NavLink>
            <a href="tel:7799880753"  className="nav-phone-btn"><FaPhone /></a>
            <button className="nav-btn nav-close-btn" onClick={showNavbar}>
              <FaTimes />
            </button>
          </nav>
          <button  className="nav-btn" onClick={showNavbar}>
            <FaBars />
          </button>
          <div className="dark-mode-toggle">
            <label className="switch">
              <input
                type="checkbox"
                checked={isDarkMode}
                onChange={toggleDarkMode}
              />
              <span className="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
